export const URL_HELPER = {
  Integrations: {
    WooComerce: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/%d7%94%d7%aa%d7%a7%d7%a0%d7%aa-%d7%a4%d7%9c%d7%90%d7%92%d7%99%d7%9f-%d7%9c-woocommerce/'
    },
    Shopify: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/pulseem-integration-for-shopify/'
    },
    CashCow: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/%d7%94%d7%aa%d7%a7%d7%a0%d7%aa-%d7%a4%d7%9c%d7%90%d7%92%d7%99%d7%9f-%d7%9c-cashcow/'
    },
    IStore: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/%d7%94%d7%aa%d7%a7%d7%a0%d7%94-%d7%95%d7%94%d7%a4%d7%a2%d7%9c%d7%aa-%d7%a4%d7%9c%d7%90%d7%92%d7%90%d7%99%d7%9f-istores/'
    },
    Ecwid: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/ecwid-pulseem/'
    },
    Wix: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/%d7%90%d7%99%d7%a0%d7%98%d7%92%d7%a8%d7%a6%d7%99%d7%94-%d7%9c%d7%97%d7%a0%d7%95%d7%aa-wix/'
    },
    eShop: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/%d7%90%d7%99%d7%a0%d7%98%d7%92%d7%a8%d7%a6%d7%99%d7%94-%d7%9c%d7%97%d7%a0%d7%95%d7%aa-e-shop/'
    },
    Klaviyo: {
      guide: 'https://site.pulseem.co.il/%D7%9E%D7%93%D7%A8%D7%9B%D7%99%D7%9D/%d7%9e%d7%93%d7%a8%d7%99%d7%9a-%d7%90%d7%99%d7%a0%d7%98%d7%92%d7%a8%d7%a6%d7%99%d7%94-%d7%9c-klaviyo/'
    }
  }
}